import React from 'react'
import PropTypes from 'prop-types'
import { Button, BUTTON_SIZES } from 'shared/UI/Button'

import './style.css.scss'

const AttendActivity = (props) => {
  return (
    <div className="attend-activity">
      <Button
        customStyle={{backgroundColor: props.themeColorHex}}
        className="attend-button"
        onClick={props.onJoin}
        size={BUTTON_SIZES.large}>
        {props.label}
      </Button>
    </div>
  )
}

AttendActivity.propTypes = {
  onJoin: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
}

export default AttendActivity
